import { createTheme, adaptV4Theme } from "@mui/material";

export const muiSwitchTheme = createTheme(adaptV4Theme({
    overrides: {
        MuiSwitch: {
            track: {
                "$checked$checked + &": {
                    opacity: 1.0,
                    backgroundColor: "rgb(255, 124, 2)"
                },
                "MuiIconButton-label": {
                    backgroundColor: "rgb(255, 124, 2)"
                }
            }
        }
    }
}));